module.exports = __webpack_public_path__ + "static/img/no-image-3.8725410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-image-3.png
// module id = 0FYu
// module chunks = 31